import React from 'react';
import TestimonialCover from "@/assets/images/testimonialCover.png";

const ClaimExperience: React.FC = () => {
  return (
    <section className="tw-bg-black tw-text-white tw-pt-24 tw-pb-32 tw-px-4">
      {/* Intro Block */}
      <div className="tw-max-w-3xl tw-mx-auto tw-mb-24">
        <h2 className="tw-text-4xl md:tw-text-6xl tw-font-bold">
          You’ve got 1,200+<br/>reasons to believe.
        </h2>
        <p className="tw-text-base md:tw-text-xl tw-text-gray-300 tw-mt-4 tw-leading-relaxed">
          Our merchants are our partners. Like Jai had Veeru, and Krishna had Arjun —{" "}
          <span className="tw-text-[#FFBA33] tw-font-semibold">We’ve got you.</span> With over
          1,200 trusted partnerships under our belt, we work hand in hand to deliver positive customer
          experiences and increased margins for merchants of all sizes and stages of growth.
        </p>
      </div>

      {/* Grid wrapper for heading + image */}
      <div className="tw-max-w-5xl tw-mx-auto tw-grid tw-grid-cols-12 tw-gap-4">
        {/* Heading */}
        <h3 className="
          tw-col-span-12
          md:tw-col-span-5 md:tw-col-start-2
          tw-text-4xl md:tw-text-5xl
          tw-font-bold tw-leading-snug
          tw-mb-8
        ">
          The proof is in<br/>the performance.
        </h3>

        {/* Image */}
        <div className="tw-col-span-12 md:tw-col-span-10 md:tw-col-start-2">
          <img
            src={TestimonialCover}
            alt="Performance statistics"
            className="tw-w-full tw-rounded-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default ClaimExperience;
